import { TParseToCheckDuplicationModel } from "../types";

export const parseToCheckDuplicationModel: TParseToCheckDuplicationModel = (
  values,
) => {
  return {
    ...(values.id && { id: values.id }),
    schoolId: values.schoolId,
    courseType: +values.courseType,
    category: values.category.trim(),
    minAge: +values.minAge,
    maxAge: values.maxAge?.trim() ? +values.maxAge : null,
    language: values.language.id,
    branches: values.branches.map((branch) => ({ branchId: branch })),
  };
};
